"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = require("bind-decorator");
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../api/ecommerce");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importStar(require("../../common/js/components/LoadingSpinner"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Dropdown_1 = __importDefault(require("../atoms/Dropdown"));
const Paths_1 = require("../constants/Paths");
const Routes_1 = __importDefault(require("../constants/Routes"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const dataLayer_1 = require("../helper/dataLayer");
const path_1 = require("../helper/path");
const ShopwareNavigation_1 = __importDefault(require("../stores/ShopwareNavigation"));
const ShopwareProducts_1 = __importDefault(require("../stores/ShopwareProducts"));
class CategoryNavigation extends react_1.default.Component {
    // @ts-expect-error Dropdown cannot be used as type.
    categoryDropdownRef = {};
    categoryDropdownLabelRef = {};
    tabsRef = react_1.default.createRef();
    contextReactionDisposer;
    showSubCategoryOfCategory = null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showSubCategoryOfCategory: mobx_1.observable,
            setShowSubCategoryOfCategory: mobx_1.action.bound,
            resetShowSubCategoryOfCategory: mobx_1.action.bound,
            updateDropdownPositions: mobx_1.action.bound,
        });
    }
    componentDidMount() {
        document.addEventListener('click', this.resetShowSubCategoryOfCategory);
        document.addEventListener('scroll', this.updateDropdownPositions);
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => [AuthorizationStore_1.default.auth0?.isLoading, AuthorizationStore_1.default.customerId], ([isLoading]) => {
            if (false === isLoading) {
                ShopwareNavigation_1.default.reset();
                ShopwareNavigation_1.default.initialize();
            }
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.resetShowSubCategoryOfCategory);
        document.removeEventListener('scroll', this.updateDropdownPositions);
        this.contextReactionDisposer?.();
    }
    render() {
        const compiledClassNames = (0, classnames_1.default)('znd-tabs position-sticky', this.props.className);
        if (ShopwareNavigation_1.default.isLoading) {
            return (react_1.default.createElement("div", { className: compiledClassNames },
                react_1.default.createElement(LoadingSpinner_1.default, { style: LoadingSpinner_1.LoadingSpinnerStyle.small, center: true })));
        }
        return (react_1.default.createElement("nav", { className: compiledClassNames, ref: this.tabsRef, onScroll: this.updateDropdownPositions }, ShopwareNavigation_1.default.mainNavigationCategories.map((category) => {
            const { id } = category;
            if (!id) {
                return null;
            }
            if (!this.categoryDropdownRef[id]) {
                this.categoryDropdownRef[id] = react_1.default.createRef();
                this.categoryDropdownLabelRef[id] = react_1.default.createRef();
            }
            const dropdownRef = this.categoryDropdownRef[id];
            const dropdownLabelRef = this.categoryDropdownLabelRef[id];
            const rootCategoryClasses = (0, classnames_1.default)('znd-tabs__item', {
                'znd-tabs__item--active': this.categoryIsActive(category),
            });
            return (react_1.default.createElement("div", { key: id, className: "znd-tabs__item-wrapper" }, !!category.children && category.children?.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { ref: dropdownLabelRef, className: rootCategoryClasses, onClick: (event) => {
                        this.setShowSubCategoryOfCategory(category, event);
                    } },
                    category.translated?.name,
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.angleDown, className: "znd-tabs__arrow" })),
                react_1.default.createElement(Dropdown_1.default, { show: category.id === this.showSubCategoryOfCategory?.id, ref: dropdownRef },
                    react_1.default.createElement(react_router_dom_1.Link, { to: this.createCategoryRoute(category), className: (0, classnames_1.default)('znd-dropdown__item', {
                            'znd-dropdown__item--active': this.rootCategoryIsActive(category),
                        }), onClick: (event) => {
                            this.resetShowSubCategoryOfCategory(event);
                            this.pushCategoryToDataLayer(category);
                        } }, (0, translation_1.t)('category_navigation.all_from_category', {
                        category: category.translated?.name,
                    })),
                    category.children?.map((subCategory) => (react_1.default.createElement(react_router_dom_1.Link, { key: subCategory.id, to: this.createCategoryRoute(category, subCategory), className: (0, classnames_1.default)('znd-dropdown__item', {
                            'znd-dropdown__item--active': this.categoryIsActive(category, subCategory),
                        }), onClick: (event) => {
                            this.resetShowSubCategoryOfCategory(event);
                            this.pushCategoryToDataLayer(category, subCategory);
                        } }, subCategory.translated?.name)))))) : (react_1.default.createElement(react_router_dom_1.Link, { to: this.getExternalLink(category) ?? this.createCategoryRoute(category), className: rootCategoryClasses, onClick: (event) => {
                    this.resetShowSubCategoryOfCategory(event);
                    this.pushCategoryToDataLayer(category);
                } }, category.translated?.name))));
        })));
    }
    pushCategoryToDataLayer(category, subcategory) {
        if (!!subcategory) {
            (0, dataLayer_1.pushToDataLayerNavigation)({
                [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('navigation.shop.title'),
                [DataLayerLabels_1.default.dlvNavigationLevelTwo]: category?.translated?.name,
                [DataLayerLabels_1.default.dlvNavigationLevelThree]: subcategory.translated?.name,
            });
            return;
        }
        (0, dataLayer_1.pushToDataLayerNavigation)({
            [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)('navigation.shop.title'),
            [DataLayerLabels_1.default.dlvNavigationLevelTwo]: category?.translated?.name,
        });
    }
    getExternalLink(category) {
        return category?.type === ecommerce_1.CategoryTypeEnum.Link ? (category.externalLink ?? null) : null;
    }
    setShowSubCategoryOfCategory(category, event) {
        event?.preventDefault();
        const dropdownInstance = this.categoryDropdownRef[category?.id ?? 0]?.current;
        window.requestAnimationFrame(() => {
            if (this.tabsRef.current && category && dropdownInstance?.dropdownRef.current) {
                const dropdownElement = dropdownInstance.dropdownRef.current;
                const dropdownElementRect = dropdownElement.getBoundingClientRect();
                const dropdownLeft = dropdownElementRect.left;
                const dropdownWidth = dropdownElementRect.width;
                const rootRect = this.tabsRef.current.getBoundingClientRect();
                const rootLeft = rootRect.left;
                const rootWidth = rootRect.width;
                const currentScroll = this.tabsRef.current.scrollLeft;
                const minLeft = 0;
                const maxRight = rootLeft + rootWidth;
                const currentLeft = dropdownLeft;
                const currentRight = currentLeft + dropdownWidth;
                let scrollOffset = 0;
                if (currentRight > maxRight) {
                    scrollOffset = maxRight - currentRight;
                }
                else if (currentLeft < minLeft) {
                    scrollOffset = minLeft - currentLeft;
                }
                const newScroll = currentScroll - scrollOffset;
                if (this.tabsRef.current.scrollTo) {
                    this.tabsRef.current.scrollTo({
                        behavior: 'smooth',
                        left: newScroll,
                    });
                }
                else {
                    this.tabsRef.current.scrollLeft = newScroll;
                }
            }
        });
        this.showSubCategoryOfCategory = category ?? null;
    }
    resetShowSubCategoryOfCategory(event) {
        if (!(event.target instanceof HTMLElement)) {
            return;
        }
        const target = event.target;
        if (Object.values(this.categoryDropdownLabelRef).some((ref) => !!ref?.current && ref.current.contains(target))) {
            return;
        }
        this.setShowSubCategoryOfCategory();
    }
    updateDropdownPositions() {
        Object.values(this.categoryDropdownRef).forEach((dropdownRef) => {
            dropdownRef.current?.updatePosition();
        });
    }
    createCategoryRoute(...categories) {
        const slug = categories.map((category) => category.id).join('/');
        return (0, path_1.localePath)(Paths_1.PATH_SHOP_PRODUCTS_SLUG).replace(':slug', slug);
    }
    getActiveCategorySlug() {
        const { location } = this.props;
        const matchedRoute = (0, react_router_config_1.matchRoutes)(Routes_1.default, location.pathname).find((match) => match.match.isExact);
        if (matchedRoute && matchedRoute.match.params.product) {
            const [, ...productCategories] = ShopwareProducts_1.default.getProduct(matchedRoute.match.params.product)?.extensions?.massiveCategoryTree?.ids ??
                [];
            return `/shop/${productCategories.join('/')}`;
        }
        else {
            return location.pathname;
        }
    }
    categoryIsActive(...categories) {
        const externalLink = this.getExternalLink((0, array_1.first)(categories));
        if (externalLink) {
            return externalLink === this.props.location.pathname;
        }
        const categoryMatches = (0, react_router_config_1.matchRoutes)([{ path: this.createCategoryRoute(...categories) }], this.getActiveCategorySlug());
        return categoryMatches.length > 0;
    }
    rootCategoryIsActive(category) {
        const matches = (0, react_router_config_1.matchRoutes)([{ path: this.createCategoryRoute(category) }], this.getActiveCategorySlug());
        return (0, array_1.first)(matches)?.match.isExact ?? false;
    }
}
__decorate([
    bind_decorator_1.bind
], CategoryNavigation.prototype, "getExternalLink", null);
__decorate([
    bind_decorator_1.bind
], CategoryNavigation.prototype, "createCategoryRoute", null);
__decorate([
    bind_decorator_1.bind
], CategoryNavigation.prototype, "getActiveCategorySlug", null);
__decorate([
    bind_decorator_1.bind
], CategoryNavigation.prototype, "categoryIsActive", null);
__decorate([
    bind_decorator_1.bind
], CategoryNavigation.prototype, "rootCategoryIsActive", null);
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(CategoryNavigation));
